import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const ITEM_HEIGHT = 60;

const TiptapSideMenu = ({ editor, position, open, onClose }) => {
  // Action mapping for each option
  const actionMap = {
    "Clear Marks": () => editor.chain().focus().unsetAllMarks().run(),
    "Clear Nodes": () => editor.chain().focus().clearNodes().run(),
    Duplicate: () => {
      const content = editor.getJSON();
      editor.commands.setContent(content, true);
    },
    Delete: () => editor.commands.clearContent(),
    "To-Do List": () => editor.chain().focus().toggleTaskList().run(),
  };

  const handleMenuOptionSelect = (option) => {
    onClose(); // Close the menu first
    const action = actionMap[option];
    if (action) {
      action(); // Execute the corresponding action
    }
  };

  const options = Object.keys(actionMap); // Generate menu items from the actionMap keys

  return (
    <Menu
      anchorReference="anchorPosition"
      anchorPosition={
        position ? { top: position.top, left: position.left } : undefined
      }
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          maxHeight: ITEM_HEIGHT * 4.5,
          width: "140px",
        },
      }}
    >
      Hello Test
      {options.map((option) => (
        <MenuItem key={option} onClick={() => handleMenuOptionSelect(option)}>
          {option}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default TiptapSideMenu;
